<template>
  <el-dialog
    title="新增盘库计划"
    :visible.sync="dialogVisible"
    width="820px"
    custom-class="create-inventory-check-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="form-line">
      <span class="form-label required">计划盘库日期</span>
      <el-date-picker
        v-model="form.planDate"
        type="date"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="请选择日期"
      ></el-date-picker>
    </div>

    <div class="form-line scopes-header">
      <span class="form-label required">盘库内容</span>
      <el-button type="text" size="small" icon="el-icon-plus" @click="addScope">添加范围</el-button>
    </div>

    <el-table :data="form.scopes" border stripe size="mini" max-height="360">
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column label="产品类型" min-width="160">
        <template slot-scope="scope">
          <el-select
            size="mini"
            filterable
            clearable
            placeholder="请选择"
            v-model="scope.row.productType"
            @change="onScopeProductTypeChange(scope.row)"
          >
            <el-option
              v-for="product in productList"
              :key="product.type || product.productType"
              :label="product.productName"
              :value="product.productType"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="颜色范围" width="150" align="center">
        <template slot-scope="scope">
          <el-radio-group v-model="scope.row.colorMode" size="mini" @change="onColorModeChange(scope.row)">
            <el-radio-button label="all">全部</el-radio-button>
            <el-radio-button label="specified">指定</el-radio-button>
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column label="采购颜色" min-width="200">
        <template slot-scope="scope">
          <el-select
            v-if="scope.row.colorMode === 'specified'"
            size="mini"
            multiple
            filterable
            clearable
            collapse-tags
            placeholder="选择采购颜色"
            v-model="scope.row.purchaseColorNames"
            :loading="scope.row.colorLoading"
            :disabled="!scope.row.productType"
          >
            <el-option
              v-for="color in scope.row.colorOptions || []"
              :key="color"
              :label="color"
              :value="color"
            ></el-option>
          </el-select>
          <span v-else class="color-all-tip">全部颜色</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="70" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            :disabled="form.scopes.length <= 1"
            @click="removeScope(scope.$index)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="form-line remark-line">
      <span class="form-label">备注</span>
      <el-input
        type="textarea"
        :rows="2"
        size="small"
        maxlength="500"
        show-word-limit
        v-model="form.remark"
        placeholder="请输入备注"
      ></el-input>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" size="small" :loading="submitting" @click="onSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import request from "../../request/requestModules.js";
import { activeProducts, allActiveProducts } from "../../utils/constant.js";

function createEmptyScope() {
  return {
    productType: "",
    productName: "",
    colorMode: "all",
    purchaseColorNames: [],
    colorOptions: [],
    colorLoading: false,
  };
}

export default {
  name: "CreateInventoryCheckDialog",
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      form: {
        planDate: "",
        remark: "",
        scopes: [createEmptyScope()],
      },
    };
  },
  methods: {
    open() {
      this.resetForm();
      this.dialogVisible = true;
    },
    resetForm() {
      const today = new Date();
      const pad = n => String(n).padStart(2, "0");
      this.form = {
        planDate: `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`,
        remark: "",
        scopes: [createEmptyScope()],
      };
      this.submitting = false;
    },
    handleClose() {
      this.resetForm();
    },
    addScope() {
      this.form.scopes.push(createEmptyScope());
    },
    removeScope(index) {
      if (this.form.scopes.length <= 1) return;
      this.form.scopes.splice(index, 1);
    },
    findProductName(productType) {
      const hit = (this.productList || []).find(item => ~~item.productType === ~~productType);
      return hit ? hit.productName || "" : "";
    },
    onScopeProductTypeChange(row) {
      row.productName = this.findProductName(row.productType);
      row.purchaseColorNames = [];
      row.colorOptions = [];
      if (row.colorMode === "specified" && row.productType) {
        this.loadColorOptions(row);
      }
    },
    onColorModeChange(row) {
      if (row.colorMode === "all") {
        row.purchaseColorNames = [];
        return;
      }
      if (row.productType) {
        this.loadColorOptions(row);
      }
    },
    loadColorOptions(row) {
      if (!row.productType) return;
      row.colorLoading = true;
      request
        .fetchProducts({
          productType: row.productType,
          beginIndex: 0,
          pageSize: 10000,
        })
        .then(res => {
          const set = new Set();
          (res.ldata || []).forEach(item => {
            if (!item || String(item.status || "") !== "Active") return;
            const name = String(item.purchaseColorName || "").trim();
            if (name) set.add(name);
          });
          row.colorOptions = [...set].sort((a, b) => (a > b ? 1 : -1));
        })
        .catch(err => {
          this.$message.error((err && err.message) || "加载采购颜色失败");
        })
        .finally(() => {
          row.colorLoading = false;
        });
    },
    buildScopesPayload() {
      const scopes = [];
      for (let i = 0; i < this.form.scopes.length; i++) {
        const row = this.form.scopes[i];
        const productType = ~~row.productType;
        if (!productType) {
          return { error: `第 ${i + 1} 段请选择产品类型` };
        }
        const colorMode = row.colorMode === "specified" ? "specified" : "all";
        const purchaseColorNames =
          colorMode === "specified"
            ? [...new Set((row.purchaseColorNames || []).map(item => String(item || "").trim()).filter(Boolean))]
            : [];
        if (colorMode === "specified" && !purchaseColorNames.length) {
          return { error: `第 ${i + 1} 段请至少选择一个采购颜色` };
        }
        scopes.push({
          productType,
          productName: row.productName || this.findProductName(productType),
          colorMode,
          purchaseColorNames,
        });
      }
      if (!scopes.length) {
        return { error: "请至少配置一段盘库内容" };
      }
      return { scopes };
    },
    onSubmit() {
      if (this.submitting) return;
      if (!this.form.planDate) {
        this.$message.warning("请选择计划盘库日期");
        return;
      }
      const built = this.buildScopesPayload();
      if (built.error) {
        this.$message.warning(built.error);
        return;
      }
      this.submitting = true;
      request
        .createInventoryCheck({
          planDate: this.form.planDate,
          scopes: built.scopes,
          remark: this.form.remark,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "新增盘库计划失败");
            return;
          }
          const planId = (res.mdata && res.mdata.planId) || "";
          this.$message.success(planId ? `新增成功，盘库单号 ${planId}` : "新增成功");
          this.dialogVisible = false;
          this.$emit("success", res.mdata || {});
        })
        .catch(err => {
          this.$message.error((err && err.message) || "新增盘库计划失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss">
.create-inventory-check-dialog {
  .form-line {
    display: flex;
    align-items: flex-start;
    margin-bottom: 12px;
  }
  .form-label {
    width: 110px;
    line-height: 32px;
    color: #606266;
    flex-shrink: 0;
  }
  .form-label.required::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
  .scopes-header {
    align-items: center;
    margin-bottom: 8px;
  }
  .color-all-tip {
    color: #909399;
    font-size: 12px;
  }
  .remark-line {
    margin-top: 12px;
    .el-textarea {
      flex: 1;
    }
  }
}
</style>
